module.exports = __webpack_public_path__ + "img/canada.7b2bd147.jpg";